/* Cart drawer "Complete your bed" (Luke 15/10/2026). Markup + data: snippets/nt-cart-pair.liquid.
   Rows sort cheapest first; picking one opens a slim bar (swatches for bases) with an Add button that adds the item
   and re-renders the drawer the same way product-card-small does. */
if (!customElements.get('nt-cart-pair')) {
  customElements.define('nt-cart-pair', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      try { this.d = JSON.parse(this.querySelector('[data-nt-cp]').textContent); } catch (e) { return; }
      this.pick = -1; this.col = null;
      this.sw = {'Light Grey':'#d3d3d1','Graphite':'#3f4044','Natural':'#e3d2b3','Naptime Grey':'#9d9ca4','Grey':'#bab6b6','White':'#eeebe4','Timber':'#e8cfa4','Black':'#1b1b1f'};
      this.render();
    }
    net(c) { return Math.round(c * (100 - (this.d.pct || 0)) / 100); }
    money(c) { const n = c / 100; return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
    ok(i) { return this.d.rows[i].v.filter((v) => v.a); }
    lo(i) { const o = this.ok(i); return o.length ? Math.min(...o.map((v) => v.p)) : null; }
    cur(i) { const R = this.d.rows[i], o = this.ok(i); return o.find((v) => (v.c || '') === (this.col || '')) || o[0] || null; }
    render() {
      const S = this.d.pct, list = this.querySelector('[data-list]');
      const order = this.d.rows.map((r, i) => i).sort((a, b) => (this.lo(a) ?? Infinity) - (this.lo(b) ?? Infinity) || a - b);
      let h = '';
      order.forEach((i) => {
        const R = this.d.rows[i], lo = this.lo(i), n = new Set(R.v.map((v) => v.c).filter(Boolean)).size;
        const v = i === this.pick ? this.cur(i) : null, bp = v ? v.p : lo;
        const sub = lo === null ? (R.v.length ? 'Sold out in ' + this.d.size : 'Not available in ' + this.d.size)
          : [R.sub, n > 1 ? n + ' colours' : ''].filter(Boolean).join(' · ');
        const price = lo === null ? '' : '+' + this.money(this.net(bp)) + (S > 0 ? ' <s>' + this.money(bp) + '</s>' : '');
        h += `<button type="button" role="radio" data-i="${i}" aria-checked="${this.pick === i}"${lo === null ? ' disabled' : ''}>
          <span class="nt-pm2__dot"></span><span class="nt-pm2__t"><b>${R.t}</b>${sub ? `<small>${sub}</small>` : ''}</span><span class="nt-pm2__p">${price}</span></button>`;
      });
      list.innerHTML = h;
      list.querySelectorAll('[data-i]').forEach((b) => b.onclick = () => {
        const i = +b.dataset.i; if (i !== this.pick) { this.pick = i; this.col = null; const v = this.cur(i); this.col = v ? v.c : null; } this.render(); });
      const bar = this.querySelector('[data-bar]');
      bar.hidden = this.pick < 0;
      if (this.pick < 0) return;
      const R = this.d.rows[this.pick], v = this.cur(this.pick);
      const cols = [...new Set(R.v.map((x) => x.c).filter(Boolean))];
      const sw = cols.map((c) => { const cv = R.v.find((x) => x.c === c);
        return `<button type="button" data-col="${c}" title="${c}" aria-label="${c}" aria-pressed="${v && c === v.c}" class="${cv && cv.a ? '' : 'nt-fb__oos'}"${cv && cv.a ? '' : ' disabled'} style="background:${this.sw[c] || '#ccc'}"></button>`; }).join('');
      bar.innerHTML = `<img src="${R.img}" alt="" width="48" height="48">
        <div class="nt-cp__mid">${sw ? `<div class="nt-fb__sw">${sw}</div>` : ''}<small>${v && v.c ? v.c + ' · ' : ''}${this.d.size}${v && v.pre ? ' · Pre-order' : ''}</small></div>
        <button type="button" class="nt-cp__add" data-add${v ? '' : ' disabled'}>Add ${this.money(this.net(v ? v.p : 0))}</button>`;
      bar.querySelectorAll('[data-col]').forEach((b) => b.onclick = () => { this.col = b.dataset.col; this.render(); });
      bar.querySelector('[data-add]').onclick = () => v && this.add(v, bar.querySelector('[data-add]'));
    }
    add(v, btn) {
      btn.disabled = true; btn.textContent = 'Adding…';
      const secs = [{ id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }];
      const fd = new FormData();
      fd.append('id', v.id); fd.append('quantity', 1);
      if (v.pre) { fd.append('properties[Pre-order]', 'Stock arriving: ' + (v.pw || 'TBC')); fd.append('properties[_preorder_container]', v.pc); }
      fd.append('sections', secs.map((s) => s.section)); fd.append('sections_url', window.location.pathname);
      fetch(theme.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) { btn.textContent = res.description || 'Couldn’t add'; return; }
          secs.forEach((s) => {
            const host = document.getElementById(s.id); if (!host || !res.sections || !res.sections[s.section]) return;
            const el = host.querySelector(s.selector) || host;
            const src = new DOMParser().parseFromString(res.sections[s.section], 'text/html').querySelector(s.selector);
            if (src) el.innerHTML = src.innerHTML;
          });
          if (typeof Cart !== 'undefined') { try { new Cart().renderContents(res); } catch (e) {} }
          const drawer = document.getElementById('Cart-Drawer');
          if (drawer && drawer.removeProductEvent) drawer.removeProductEvent();
          if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart:item-added', { product: res });
        })
        .catch(() => { btn.disabled = false; btn.textContent = 'Try again'; });
    }
  });
}
